
<div mat-dialog-content><div style="float: right !important;">
    <a
      href="javascript:void(0)"
      (click)="closeModal()"
      style="color: #8f8f8f">
      <mat-icon
        style="size: 18px;"
        matTooltip="Close form"
        matTooltipPosition="below">
        close
      </mat-icon>
    </a>
  </div>
  <div class="video-embed">
    <iframe  [src]="url"  frameborder="0"  width="600px" height="500px" allowfullscreen></iframe>
  </div>
  </div>  